export default "__VITE_ASSET__DUd2SjIV__"